import { useStaticQuery, graphql } from "gatsby";

import { useCurrentLang } from "@hooks/useLocalizedCartInfo";
import useIsHydrationComplete from "@hooks/useIsHydrationComplete";

import { edgesToArray } from "@helpers/general";

export default function useTargetedProductText(tags) {
  const lang = useCurrentLang();
  const data = useStaticQuery(graphql`
    query TargetedProductText {
      allContentfulTargetedProductText {
        edges {
          node {
            id
            node_locale
            name
            message
            tag
            startsAt
            expiresAt
          }
        }
      }
    }
  `);

  const isHydrationComplete = useIsHydrationComplete();
  if (!isHydrationComplete) {
    return null;
  }
  const now = Date.now();

  const entries = edgesToArray(data?.allContentfulTargetedProductText);

  const targetedText = entries.find((entry) => {
    const isTagMatch = tags?.includes(entry.tag) ?? false;
    const isLocaleMatch = entry.node_locale === lang;
    const isActive =
      (!entry.startsAt || new Date(entry.startsAt).getTime() <= now) &&
      (!entry.expiresAt || new Date(entry.expiresAt).getTime() >= now);
    return entry.message && isTagMatch && isLocaleMatch && isActive;
  });

  return targetedText?.message ?? null;
}
